import * as React from "react";
import {Box, Tab} from "@mui/material";
import MUITabs from "@mui/material/Tabs";


export const Tabs = ({items}) => {
    const [value, setValue] = React.useState(0);

    return (
        <>
            <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                <MUITabs value={value} onChange={(e, v) => setValue(v)}>
                    {items.map(item => <Tab key={item.title} label={item.title}/>)}
                </MUITabs>
            </Box>
            {items[value].component}
        </>
    );
}
